import { CommunityFeed } from '@/types'
import { communityAnalytics, useVolume } from '@/utils'
import { memo, useCallback } from 'react'
import { ActionButton } from '../../atoms/ActionButton'

const UnMemoizedVolume = ({ item }: { item: CommunityFeed }) => {
  const volume = useVolume()

  const handleToggleVolume = useCallback(async () => {
    volume.toggleMuted()

    if (!volume.muted) {
      communityAnalytics.feedActionEvent('feed_sound_on', item)
    } else {
      communityAnalytics.feedActionEvent('feed_sound_off', item)
    }
  }, [volume.muted])

  const hasVideo = !!item.post?.video?.url

  if (!hasVideo) return null

  return (
    <ActionButton
      icon={volume.muted ? 'volume-1' : 'volume-high'}
      text={volume.muted ? 'Off' : 'On'}
      onPress={handleToggleVolume}
    />
  )
}

export const Volume = memo(UnMemoizedVolume)
